angular.module("digitalLeasing.module").component("accordionAliquota", {
    templateUrl: "ng/components/digitalLeasing/goodManagement/accordionAliquota/accordionAliquota.view.html",
    bindings: {
        model: "=",
        aliquotaIsOk: "&",
        aliquotaIsNotOk: "&",
        financialModel: '<'
    },
    controllerAs: "accordionAliquotaCtrl",
    controller: AccordionAliquotaController
});

function AccordionAliquotaController($financialApiService, GeneralIdDescription) {
    var self = this;

    self.$onInit = function () {
        self.ivaAppaltoList = [];
        self.supportModel = {
            ivaAppaltoSelected: {
                cdAlqIva: self.model.bene.ivaAppalto.id,
                dsAlqIva: self.model.bene.ivaAppalto.description
            }
        }

        getIva();
        validationComponent();
    };

    self.handleChange = function (value) {
        if (value) {
            self.model.bene.ivaAppalto = GeneralIdDescription.build({
                id: value.cdAlqIva,
                description: value.dsAlqIva
            });

            self.supportModel.ivaAppaltoSelected.cdAlqIva = value.cdAlqIva;
            self.supportModel.ivaAppaltoSelected.dsAlqIva = value.dsAlqIva;

            validationComponent();
        }
    }
    var getIva = function () {
        $financialApiService
            .getIva()
            .then(function (response) {
                self.ivaAppaltoList = response;

            }).catch(function (error) {
                console.error(error);
            });
    }

    var validationComponent = function () {
        var test = false;

        if (self.model.id === "IMC") {
            test = self.model.bene.ivaAppalto.id && self.model.bene.ivaAppalto.description;
        } else {
            test = true;
        }

        if (test) {
            self.aliquotaIsOk();
        } else {
            self.aliquotaIsNotOk();
        }

    }
}